// @flow
import React from 'react';
import type {Node} from 'react';
import moment from 'moment';
import type {UICalendarEventType} from '@wellstone-solutions/common';
import {useCalendarEventStyles} from '../../hooks/useCalendarEventStyles';
import {CalendarEvent} from './CalendarEvent';

type PropsType = {
  continuesAfter: boolean,
  continuesPrior: boolean,
  currentView: string,
  event: {
    allDay: boolean,
    end: Date,
    isAttending: boolean,
    isGroupEvent: boolean,
    resource: UICalendarEventType,
    start: Date,
    title: string,
  },
  isAllDay: boolean,
  localizer: any,
  slotEnd: Date,
  slotStart: Date,
  title: string,
};

export const MonthlyEvent = ({
  isAllDay,
  event,
  currentView,
  title,
}: PropsType): Node => {
  const {isAttending, isGroupEvent} = event;
  const styles = useCalendarEventStyles({isAttending, isGroupEvent});

  return (
    <CalendarEvent
      isAllDay={isAllDay}
      startTime={moment(event.start).format('h:mm a')}
      styles={styles}
      title={title}
    />
  );
};
